import { FC } from 'react';
import { useGetDeliveryZone } from './hooks';
import { useTranslation } from 'react-i18next';
import { Suggester } from '@/shared/components';
import { setAreAnotherManualCoordinates, setAreManualCoordinates, useAppDispatch, useAppSelector } from '@/app/store';

interface DeliverySuggesterProps {
  className?: string;
  inCatalog?: boolean;
  onSuccess: VoidFunction;
  inputClassName?: string;
  isOrderAnotherPerson?: boolean;
  resetManualCoordinates?: boolean;
  isDesktop?: boolean;
}

export const DeliverySuggester: FC<DeliverySuggesterProps> = ({
  onSuccess,
  inCatalog = false,
  isOrderAnotherPerson = false,
  resetManualCoordinates = false,
  ...props
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('address');
  const { infoLoading } = useAppSelector((state) => state.order);

  const { suggestions, inputedAddress, setInputedAddress, handleSuggestionSelect } = useGetDeliveryZone({
    onSuccess,
    inCatalog,
    isOrderAnotherPerson,
  });

  return (
    <Suggester
      {...props}
      loading={infoLoading}
      inCatalog={inCatalog}
      value={inputedAddress}
      suggestions={suggestions}
      setValue={setInputedAddress}
      placeholder={t('placeholders.address')}
      onSuggestionSelect={(suggestion) => {
        if (resetManualCoordinates) {
          if (isOrderAnotherPerson) dispatch(setAreAnotherManualCoordinates(false));
          else dispatch(setAreManualCoordinates(false));
        }
        handleSuggestionSelect(suggestion);
      }}
      onSuccess={onSuccess}
    />
  );
};
